<template>
  <autosized-collapsible-footer :expanded="drawerExpanded" @update:expanded="$emit('update:drawerExpanded', $event)">

    <template #expand-button-label>popular inquiries</template>
    <div class="header mr-1 sm:mr-6 mb-1.5 text-xl">
      <span class="hidden md:inline-block">popular inquiries</span>
    </div>

    <div class="presets-container flex overflow-x-auto p-4 pt-0 pb-3 gap-4">
      <template v-for="(preset, i) in popularInquiries">
        <div :key="i"
             class="preset-tile border border-solid border-blue
                    rounded w-40 h-40 p-2 text-center text-blue
                    flex flex-col justify-between"
             style="min-width: 160px"
        >
          <div class="preset-tile__loader m-auto" v-if="!eventTypes.length || !kpis.length">
            <loading-icon class="m-auto" />
            <span>Loading preset</span>
          </div>
          <template v-else>
            <span class="preset-tile__text">
              see which
              <strong>{{ eventTypes.length && eventTypes.find(e => e.key === preset.event).short_label }}</strong>
              has the biggest impact on
              <strong>{{ kpis.length && kpis.find(k => k.key === preset.kpi).label }}</strong>
            </span>
            <button class="preset-tile__button sb-button button mx-2 p-0 py-0.5"
                    :disabled="isLoadingReport"
                    @click="onPresetClick(preset)"
            >
              see impact
            </button>
          </template>
        </div>
      </template>
    </div>

  </autosized-collapsible-footer>
</template>

<script>
import AutosizedCollapsibleFooter from "../../../components/shared/AutosizedCollapsibleFooter";
import {LoadingIcon} from '@springbig/sb-components'

export default {
  name: 'PopularInquiriesDrawer',
  components: {AutosizedCollapsibleFooter, LoadingIcon},
  props: {
    drawerExpanded: Boolean,
    eventTypes: Array,
    kpis: Array,
    onPresetClick: Function,
    isLoadingReport: Boolean
  },
  data() {
    return {
      popularInquiries: [
        {event:'brand_purchased', kpi:'average_ticket'},
        {event:'brand_purchased', kpi:'total_spend'},
        {event:'reward_redeemed', kpi:'total_visits'},
        {event:'offer_redeemed', kpi:'average_ticket'},
        {event:'visit_count_achieved', kpi:'average_ticket'},
        {event:'redemption_count_achieved', kpi:'average_ticket'},
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.button {
  font-family: "AileronThin", sans-serif;
  font-size: 18px;
}

.events-dropdown ::v-deep {
  width: fit-content;
  min-width: 300px;
  margin: 0 0 16px;
  white-space: nowrap;
}

.preset-tile__text {
  font-size: 1rem;
  line-height: 1.25rem;
}

.collapsible-display::v-deep {
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 1.2rem;
    line-height: 1.8rem;
    padding: 5px 20px 0;
    white-space: nowrap;
  }
  .open-button {
    color: #128ff9;
    background-color: white;
  }
}
</style>
